/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api/extensionsApi.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    API calls for fetching extensions for Pickup Groups.
────────────────────────────────────────────────────────────────*/

import { buildApiUrl, getApiHeaders } from '../../../config/api';

export interface Extension {
  id: string;
  name: string;
  description?: string;
  slug?: string;
}

export async function fetchExtensions(): Promise<Extension[]> {
  const response = await fetch(
    buildApiUrl('/api/telephony/extensions?limit=500&sortBy=extension&sortOrder=asc'),
    {
      headers: getApiHeaders()
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch extensions');
  }

  const result = await response.json();

  if (result.success && Array.isArray(result.data)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return result.data.map((ext: any) => ({
      id: ext.extension,
      name: `${ext.extension}${ext.name ? ` - ${ext.name}` : ''}`,
      description: ext.name || '',
      slug: ext.extension
    }));
  }

  return [];
}

